var _require = require('../overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
module.exports = function (value) {
  var safeValue = String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  return buildRustscriptOverlay({
    className: 'rs-overlay-prompt rs-prompt-publickey-panel',
    title: 'Public Key',
    bodyHtml: "\n      <input\n        type=\"text\"\n        class=\"saito-input rs-prompt-value rs-prompt-publickey-input\"\n        value=\"".concat(safeValue, "\"\n        placeholder=\"Saito public key\"\n        autocomplete=\"off\"\n        spellcheck=\"false\"\n      />\n      <p class=\"rs-prompt-validation\" hidden></p>\n    "),
    actionsHtml: "\n      <button type=\"button\" class=\"rs-btn rs-btn-secondary rs-prompt-use-mine\">Use My Public Key</button>\n      <button type=\"button\" class=\"rs-btn rs-btn-primary rs-prompt-apply\">Apply</button>\n    ",
    actionsClass: 'rs-overlay-actions-split'
  });
};